import { SERVICES_ENV } from '@/env';

export function configureMetaPixel() {
  const pixelId = SERVICES_ENV.META_PIXEL_ID;
  if (!pixelId) return;

  /* eslint-disable */
  // @ts-ignore — vendor snippet from Meta
  !(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  (window as any).fbq('init', pixelId);
  (window as any).fbq('track', 'PageView');
}
